import { mergeGraph, registerGraph } from '@/angular/modules/vrm-graph/config-utils';


registerGraph('energyPricesGraph', energyPricesGraph);

/* @ngInject */
function energyPricesGraph(GraphService, EssGraphService, locale, defaultGraph, nowIndicatorConfig) {

    return mergeGraph(defaultGraph(), nowIndicatorConfig(), {
        size: {
            height: null // fix to make it scale to container height
        },
        options: {
            chart: {
                plotBackgroundColor: '#f0efeb',
                height: null,
                marginBottom: 70, // to make space for longer time labels i.e. '17. Aug 02:00'
                marginLeft: 48, // to have the width of the left axis panel fixed
            },
            plotOptions: {
                line: {
                    pointInterval: 1000 * 60 * 60,
                    marker: {
                        enabled: false
                    }
                }
            },
            tooltip: EssGraphService.getTooltipFormatter(GraphService, null, undefined, true)
        },
        chart: {
            type: 'line',
            styledMode: true
        },
        xAxis: {
            type: 'datetime',
            labels: { formatter: GraphService.datetimeLabeler() },
            startOfWeek: 1,
            tickInterval: 1000 * 60 * 60,
            minPadding: 0,
            maxPadding: 0,
            offset: 0,
            lineWidth: 0,
            plotLines: [
                {
                    color: GraphService.colors.lightGrey,
                    value: null,
                    width: 1,
                    zIndex: 4
                }
            ]
        },
        yAxis: [
            {
                title: {
                    text: '',
                    align: 'high',
                    y: -30,
                    rotation: 0,
                    offset: 0
                },
                plotLines: [
                    {
                        color: GraphService.colors.lightGrey,
                        value: 0,
                        width: 1,
                    }
                ],
                gridLineWidth: 0,
                visible: true,
                showFirstLabel: true,
               labels: {
                    formatter: function () {
                        const tickPositions = this.axis.tickPositions;
                        const maxDecimals = tickPositions.reduce((max, pos) => {
                            const decimals = (pos.toString().split('.')[1] || '').length;
                            return Math.max(max, decimals);
                        }, 0);
                        return Number(this.value).toFixed(maxDecimals);
                    }
                },
                softMin: 0,
            },
        ],
        series: [
            {
                name: locale.getString('graph.buy_price'),
                type: "line",
                step: "left",
                id: "buy_price",
                color: EssGraphService.getColumnColor(EssGraphService.colors.RED),
                borderColor: EssGraphService.getColumnColor(EssGraphService.colors.RED),
                lineWidth: 1.2,
                visible: false,
                data: [],
                zoneAxis: 'x',
                zones: [
                    {
                        value: 0,
                        dashStyle: 'solid'
                    },
                    {
                        dashStyle: 'shortDash'
                    },
                ]
            },
            {
                name: locale.getString('graph.sell_price'),
                type: "line",
                step: "left",
                id: "sell_price",
                color: EssGraphService.getColumnColor(EssGraphService.colors.GREEN),
                borderColor: EssGraphService.getColumnColor(EssGraphService.colors.GREEN),
                lineWidth: 1.2,
                visible: false,
                data: [],
                zoneAxis: 'x',
                zones: [
                    {
                        value: 0,
                        dashStyle: 'solid'
                    },
                    {
                        dashStyle: 'shortDash'
                    },
                ]
            },
        ]
    });
}
